/** 半角数値のみ（空文字NG）*/
export const NUMERIC = /^[0-9]+$/;

/** 半角数字以外 */
export const NOT_HALF_WIDTH_NUMERIC = /[^0-9]/g;

/** 電話番号（半角数値のみ、または、接頭に+が付き以降が半角数値のみ） */
export const PHONE_NUMBER = /^[+][0-9]+$|^[0-9]+$/;

export const FULL_WIDTH_KATAKANA = /^[ァ-ンヴー]+$/;

/**
 * ex: zenToHan("１２３") => "123"
 * @param str
 */
export function zenNumToHan(str: string): string {
    return str.replace(/[０-９]/g, s => {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
}
